/* Pulled from worker living at /workers/mdparser.js in Ember application, with some modifications */
import { flow } from 'lodash';
function removeHtml(content) {
    return content.replace(/(?:<([^>]+)>)/gi, '');
}
function parseBoldAndItalics(content) {
    // ***Bold + Italics***
    return content.replace(/\*\*\*(.*?)\*\*\*/gm, '<strong><em>$1</em></strong>');
}
function parseBold(content) {
    // **Bold**
    return content.replace(/\*\*(.*?)\*\*/gm, '<strong>$1</strong>');
}
function parseItalics(content) {
    // *italics* (make sure to parse bold prior to this)
    return content.replace(/\*(.*?)\*/gm, '<em>$1</em>');
}
function parseLinks(content) {
    // [this is a google link](https://www.google.com)
    // we treat all links as external links.  We leave it up to the consumer (spa) to intercept the link click and handle as needed
    return content.replace(/[\[]{1}([^\]]+)[\]]{1}[\(]{1}([^\)\"]+)(\"(.+)\")?[\)]{1}/g, // eslint-disable-line no-useless-escape
    '<a href="$2" title="$4" target="_blank" rel="noopener noreferrer">$1</a>');
}
function parseLineBreaks(content) {
    // *line breaks*
    return content.replace(/\n/gm, '<br />');
}
export var parseContent = function (content) {
    // sanitize html and parse each supported md tag - note this order is significant
    var parse = flow(removeHtml, parseBoldAndItalics, parseBold, parseItalics, parseLinks, parseLineBreaks);
    return parse(content);
};
//# sourceMappingURL=mdparser.js.map